import { useState, useEffect } from "react"

import useFetch from "shared/model/useFetch"

/**
 * @Desc 트라이아웃 실기 리스트 Api
 * 필기시험 합격자 여부를 판단할 수 있어야함
 * 실기시험 금액은?
 * 결제 완료시 트라이아웃 참가권 발행해야함
 * 실기 결제 완료즉시에는, QR코드 형식으로 발급해야함
 * 초기상태는 미사용
 * 단, 실기시험에 대해 재결재가 필요한 경우는, 기존참가권이 사용됨 상태인 경우,
 * 단, 필기는 무관하게 실기시험만 재결제 가능해야함
*/
const useGetRealExamList = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [tempData, setTempData] = useState({statusCode: 200, data:{
        rookie: {
            created_at: "2025-07-03T14:43:04.611Z",
            idx: 19,
            is_available: false,
            pro_grade_flag: 3,
            rn: "1",
            version: 2,
        },
        semi:{
            created_at: "2025-07-02T09:25:58.374Z",
            idx: 16,
            is_available: false,
            pro_grade_flag: 5,
            rn: "1",
            version: 0,
        },
        tour: {
            created_at: "2025-07-02T09:25:58.376Z",
            idx: 17,
            is_available: false,
            pro_grade_flag: 7,
            rn: "1",
            version: 0,
        }
    }})

    // api 추가 대기
    // useEffect(() => {
    //     fetchRequest("GET", `/tryout/list`)
    // }, [])

    // return [fetchResult]

    // 임시 예상 데이터
    return [tempData]
}

export default useGetRealExamList